import * as React from "react";
import styled, { useTheme } from "styled-components";
import { CSSTransition } from "react-transition-group";

type CascadeMenuPanelProps = {
    active?: boolean
    subMenu?: boolean
    className?: string
    onActive?: (elem: HTMLElement) => void
}

const StyledCascadeMenuPanel = styled.div<CascadeMenuPanelProps>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;

    // Force some appearance on enter
    &.active-appear,
    &.active-appear-done {
        opacity: 1;
        transform: translateX(0);
    }

    // Enter animations
    &.active-enter {
        opacity: 0;
        transform: translateX(${props => props.subMenu ? "100%" : "-100%"});
    }
    &.active-enter-active,
    &.active-enter-done {
        opacity: 1;
        transform: translateX(0);
    }

    // Exit animations
    &.active-exit {
        opacity: 1;
        transform: translateX(0);
    }
    &.active-exit-active,
    &.active-exit-done {
        opacity: 0;
        transform: translateX(${props => props.subMenu ? "100%" : "-100%"});
    }

    // Transition 
    &.active-exit-active,
    &.active-enter-active {
        // Same transition in all cases...
        transition: 
            transform ${props => props.theme.transitions.long} ease, 
            opacity ${props => props.theme.transitions.long};
    }
`;

export const CascadeMenuPanel: React.FC<CascadeMenuPanelProps> = (props) => {
    const { active, subMenu, onActive, children } = props;
    const theme = useTheme();

    return <CSSTransition
        unmountOnExit appear
        in={active}
        timeout={parseInt(theme.transitions.long, 10)}
        onEnter={onActive}
        classNames={"active"}>
        <StyledCascadeMenuPanel className={props.className} subMenu={subMenu}>
            {children}
        </StyledCascadeMenuPanel>
    </CSSTransition>
}